import '../../assets/components/NutritionalAttributeHighlight/nutritionalattributehighlights.css';const t = "_container_tulq0_1", n = "_certOnlyContainer_tulq0_2", e = "_hidden_tulq0_6", r = "_elements_tulq0_9", l = "_certWrapper_tulq0_27", o = "_highlightContainer_tulq0_54", _ = "_symbol_tulq0_62", i = {
  container: t,
  certOnlyContainer: n,
  hidden: e,
  elements: r,
  certWrapper: l,
  highlightContainer: o,
  symbol: _
};
export {
  n as certOnlyContainer,
  l as certWrapper,
  t as container,
  i as default,
  r as elements,
  e as hidden,
  o as highlightContainer,
  _ as symbol
};
